import { render, staticRenderFns } from "./MessageDoctorForm.vue?vue&type=template&id=1f39c92a"
import script from "./MessageDoctorForm.vue?vue&type=script&lang=js"
export * from "./MessageDoctorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports